// @flow
import * as React from 'react';
import FaiBox from "../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../MuiComponents/FaiTypography";
import theme from "../../../../assets/theme";
import {Card as MuiCard, Grid} from "@mui/material";

type CardProps = {
    data?: any;
    children?: React.ReactNode;
    bgColor: string;
    icon: any;
    title: string;
    count: number;
};

export const InventoryCard = (props: CardProps) => {
    const {typography} = theme;
    const {bgColor, count, icon, title} = props;
    return (
        <MuiCard sx={{
            borderRadius: "4px",
            minWidth: "264px",
            height: "72px",
        }}>
            <FaiBox p={"7px 12px 7px 12px"}>
                <FaiBox>
                    <Grid container alignItems="center">
                        <Grid item>
                            <FaiBox
                                bgColor={bgColor}
                                width="3rem"
                                height="3rem"
                                borderRadius="section"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                shadow="md"
                            >
                                <FaiBox component={"img"} src={icon} height="29px" color="inherit"/>


                            </FaiBox>
                        </Grid>
                        <Grid item xs={8}>
                            <FaiBox ml={2} lineHeight={1}>
                                <FaiTypography
                                    fontWeight={typography.fontWeightBold}
                                >
                                    {count}
                                </FaiTypography>
                                <FaiTypography
                                    variant="caption"
                                >
                                    {title}
                                </FaiTypography>
                            </FaiBox>
                        </Grid>
                    </Grid>
                </FaiBox>
            </FaiBox>
        </MuiCard>
    );
};
